import { Box, Stack } from "@mui/material";
import React from "react";
import { FontStyle, JobDisplays } from "../../constants";
import { jobButtonStyle, JobFontSize } from "../../utils/jobUtils";

import fireIcon from "../../img/fire2.png";
import laptopIcon from "../../img/laptop.png";

const focusTransitionSec = 0.4;
const styles = {
  container: {
    width: "100%",
    // height: '100%',
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    px: "0px",
    ...FontStyle.body,
    minWidth: "",
    zIndex: 1,
    // make text unselctable
    userSelect: "none",
  },
  title: {
    fontSize: JobFontSize.title,
    color: "#000",
    textAlign: "center",
    fontWeight: "bold",
  },
  toggleLabel: (large) => {
    return {
      ...FontStyle.body,
      // ...FontStyle.headingBody,
      fontSize: large ? JobFontSize.large : JobFontSize.medium,
      color: "#aaa",
      transition: `all ${focusTransitionSec}s ease`,
    };
  },
  toggleLabelChecked: {
    color: "#000",
  },
};

// const StudyToggle = () => {
//   return (
const focusWidth = 70;
const focusHeight = 28;
const focusPadding = 2;
const FocusToggle = ({ checked, setChecked, large }) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      // justifyContent="space-between"
      alignItems="center"
      spacing={large ? 4 : 1.75}
      sx={
        {
          // px: 5,
          // width: "100%",
        }
      }>
      <Box
        sx={{
          ...styles.toggleLabel(large),
          ...(!checked && styles.toggleLabelChecked),
        }}>
        Explore
      </Box>
      <Box
        sx={{
          width: `${focusWidth}px`,
          height: `${focusHeight}px`,
          borderRadius: `${focusHeight / 2}px`,
          // background: "linear-gradient(90deg, #48b1bf, #06beb6)",
          background: "linear-gradient(270deg, rgba(250, 250, 150,1), #6dd5ed)",
          // backgroundColor: checked ? "#c2c2c2" : "#211042",
          // background: checked
          //   ? "linear-gradient(90deg, #c2c2c2 0%, #c2c2c2 100%)"
          //   : "linear-gradient(90deg, #211042 0%, #211042 100%)",
          cursor: "pointer",
          position: "relative",
          transition: `all ${focusTransitionSec}s ease`,
        }}
        onClick={() => setChecked(!checked)}>
        {/* new background when checked*/}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: `${focusHeight / 2}px`,
            // background: "black",
            background: "linear-gradient(270deg, #000, #333)",
            opacity: 0.1,
            transition: `all ${focusTransitionSec}s ease`,
            ...(checked && {
              opacity: 1,
            }),
          }}
        />
        <Box
          sx={{
            width: `${focusHeight - focusPadding * 2}px`,
            height: `${focusHeight - focusPadding * 2}px`,
            borderRadius: "50%",
            backgroundColor: "#fff",
            position: "absolute",
            top: `${focusPadding}px`,
            left: checked
              ? `${focusWidth - focusHeight + focusPadding}px`
              : `${focusPadding}px`,
            transition: `all ${focusTransitionSec}s ease`,
            overflow: "hidden",
            // transition: `all 0.3s ease`,
          }}>
          <Box
            sx={{
              position: "absolute",
              // top: "2px",
              // left: "3.5px",
              top: "3.5px",
              left: "3px",
              transition: `all ${focusTransitionSec * 2}s ease`,
              ...(checked && {
                transform: "rotate(-45deg) translate(40px)",
              }),
            }}>
            <img src={fireIcon} width="17px" height="17px" />
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "3.5px",
              left: "3.5px",
              transition: `all ${focusTransitionSec * 2}s ease`,
              ...(!checked && {
                transform: "rotate(45deg) translate(-40px)",
              }),
            }}>
            <img src={laptopIcon} width="17px" height="17px" />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          ...styles.toggleLabel(large),
          ...(checked && styles.toggleLabelChecked),
        }}>
        Focus
      </Box>
    </Stack>
  );
};

const JobResourceHeader = ({
  checked,
  setChecked,
  large,
  setShowDescriptionOverlay,
}) => {
  const [hover, setHover] = React.useState(false);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      spacing={large ? 2 : 1.5}
      onMouseEnter={() => {
        setHover(true);
        setShowDescriptionOverlay("all");
      }}
      onMouseLeave={() => {
        setHover(false);
        setShowDescriptionOverlay("");
      }}>
      <Box
        sx={{
          ...styles.title,
          fontSize: large ? JobFontSize.title : JobFontSize.large,
        }}>
        Recruiting Resources <span style={{ paddingLeft: "4px" }}>📌</span>
      </Box>
      <FocusToggle checked={checked} setChecked={setChecked} large={large} />
      {/* <Box sx={jobButtonStyle}>Download Our Free Resume Template</Box> */}
    </Stack>
  );
};

export default JobResourceHeader;
